module.exports = __webpack_public_path__ + "static/media/goblin_bow.3cb90ef7.png";